export default "__VITE_ASSET__Cwo7Zf0d__"